// RemitentesAutorizadosPanel.js — remitentes autorizados para que
// procesarBandejaGastos.js extraiga sus PDF automáticamente. Solo admin.
import React, { useState, useEffect, useCallback } from 'react';
import { authService } from '../../services/authService';

export default function RemitentesAutorizadosPanel() {
  const [remitentes, setRemitentes] = useState([]);
  const [seedInfo, setSeedInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [nuevoEmail, setNuevoEmail] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(() => {
    setLoading(true); setError('');
    fetch('/.netlify/functions/getConfigRemitentesAutorizados', { headers: { ...authService.authHeader() } })
      .then(r => r.json())
      .then(data => { if (!data.success) { setError(data.error); return; } setRemitentes(data.remitentes); setSeedInfo(data.seedInfo); })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const handleAnadir = async () => {
    if (!nuevoEmail.trim()) return;
    setGuardando(true); setError('');
    try {
      const res = await fetch('/.netlify/functions/saveConfigRemitentesAutorizados', {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authService.authHeader() },
        body: JSON.stringify({ email: nuevoEmail.trim() }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      setNuevoEmail('');
      cargar();
    } catch (e) {
      setError(e.message);
    } finally {
      setGuardando(false);
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Quitar este remitente autorizado? Sus próximos correos pasarán a "Remitente no autorizado".')) return;
    try {
      const res = await fetch('/.netlify/functions/saveConfigRemitentesAutorizados', {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authService.authHeader() },
        body: JSON.stringify({ accion: 'eliminar', id }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error);
      cargar();
    } catch (e) {
      setError(e.message);
    }
  };

  if (loading) return <div className="flex justify-center py-10"><div className="animate-spin rounded-full h-6 w-6 border-b-2 border-red-500" /></div>;

  return (
    <div className="space-y-4">
      {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-2 text-sm">{error}</div>}

      <div className="bg-white rounded-2xl border shadow-sm p-5">
        <h3 className="font-bold text-gray-900 text-sm mb-1">Añadir remitente autorizado</h3>
        <p className="text-[11px] text-gray-400 mb-3">Solo los PDF de estos remitentes se extraen automáticamente. El resto queda visible como "Remitente no autorizado", sin procesar.</p>
        <div className="flex gap-2">
          <input
            className="flex-1 border rounded-lg px-3 py-2 text-sm"
            placeholder="proveedor@ejemplo.com"
            value={nuevoEmail} onChange={e => setNuevoEmail(e.target.value)}
          />
          <button onClick={handleAnadir} disabled={guardando} className="px-3 py-2 bg-red-600 text-white text-xs font-bold rounded-lg hover:bg-red-700 disabled:opacity-60">
            {guardando ? 'Añadiendo…' : 'Añadir'}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
        <div className="px-5 py-3 border-b bg-gray-50">
          <h3 className="font-bold text-sm text-gray-900">Remitentes autorizados</h3>
        </div>
        <div className="divide-y divide-gray-50">
          {seedInfo && (
            <div className="flex items-center justify-between px-4 py-2.5 text-xs">
              <span className="font-mono text-gray-700">{seedInfo.email} <span className="text-gray-400">(valor inicial — correo de la oficina)</span></span>
            </div>
          )}
          {remitentes.map(r => (
            <div key={r.id} className="flex items-center justify-between px-4 py-2.5 text-xs">
              <span className="font-mono text-gray-700">{r.email}</span>
              <button onClick={() => handleEliminar(r.id)} className="text-red-600 hover:underline">Quitar</button>
            </div>
          ))}
          {remitentes.length === 0 && !seedInfo && (
            <div className="text-center py-6 text-gray-400 text-xs">Sin remitentes configurados</div>
          )}
        </div>
      </div>
    </div>
  );
}
